/**
 * @module formDataIterable
 * @since 2.0.0
 */

/**
 * Generates an  iterable array member from a form element.
 * @param  {HTMLInputElement} field An HTML form input element.
 * @return {Array}
 */
const iteratize = (field) => [field.name, field.value];

/**
 * Generates an iterable array from a form element in a manner compliant with all browsers.
 * @param  {HTMLFormElement} formElement A <form> element.
 * @return {Array}                       An iterable array, similar to FormData.entries().
 */
export function formDataIterable(formElement) {
    return [].reduce.call(formElement.elements, (data, field) => {
        switch (field.type) {
            case 'submit':
            case 'button':
            case 'reset':
            case 'file':
                break;
            case 'checkbox':
            case 'radio':
                field.checked && data.push(iteratize(field));
                break;
            case 'select-multiple':
                [].forEach.call(field.options, (option) => {
                    option.selected && data.push([field.name, option.value]);
                });
                break;
            default:
                data.push(iteratize(field));
                break;
        }

        return data;
    }, []);
}
